module.exports = __webpack_public_path__ + "img/banner-principal.7187baca.svg";